import * as React from 'react';
var LegacySelectContext = /*#__PURE__*/React.createContext(null);
export default LegacySelectContext;